'use client';

import { Link } from '@/i18n/navigation';
import clsx from 'clsx';
import type { ComponentProps } from 'react';

type Props = ComponentProps<typeof Link> & {
    isActive?: boolean;
};

export default function NavigationLink({ href, isActive = false, onClick, ...rest }: Props) {
    return (
        <Link
            aria-current={isActive ? 'page' : undefined}
            className={clsx(
                'inline-block px-3 py-3 transition-colors',
                isActive ? 'bg-white/30 rounded-[8px]' : 'text-white hover:text-gray-400 duration-300',
            )}
            href={href}
            onClick={onClick}
            {...rest}
        />
    );
}
